<template>
    <div
        class="step flex flex-col items-center justify-center pb-16"
        style="position: relative"
    >
        <!-- Card with program image -->
        <div class="relative flex flex-col items-center z-10">
            <div
                class="relative rounded-xl flex flex-col"
                style="
                    width: 288px;
                    height: 184px;
                    shrink: 0;
                    border-radius: 12px;
                    background:
                        linear-gradient(
                            90deg,
                            rgba(248, 248, 249, 0) 40%,
                            #f8f8f9 100%
                        ),
                        #fff;
                    box-shadow:
                        0px 7px 29px 0px rgba(100, 100, 111, 0.2),
                        0px 1px 2px 0px rgba(0, 0, 0, 0.06);
                    padding: 18px;
                "
            >
                <!-- Background SVG -->
                <div
                    class="absolute inset-0 overflow-hidden rounded-xl pointer-events-none"
                    style="z-index: 1"
                >
                    <IconProgram icon="background-vector" />
                </div>

                <!-- Top section -->
                <div
                    class="flex justify-between items-start w-full relative"
                    style="z-index: 2"
                >
                    <div
                        class="flex flex-col"
                        style="max-width: calc(100% - 70px)"
                    >
                        <p
                            class="font-['Inter']"
                            style="
                                color: #1e293b;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 32px;
                            "
                        >
                            {{ formattedPoints }}
                        </p>
                        <p
                            class="font-['Inter'] break-words"
                            style="
                                color: #64748b;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px;
                            "
                        >
                            {{ chosenProgram ? chosenProgram.name : '' }}
                        </p>
                    </div>

                    <div>
                        <img
                            v-if="chosenProgram && chosenProgram.image"
                            :src="getProgramImageUrl(chosenProgram.image)"
                            :alt="chosenProgram ? chosenProgram.name : ''"
                            class="max-h-12 w-auto object-contain"
                        />
                    </div>
                </div>

                <div class="grow" style="z-index: 2"></div>

                <!-- Bottom section with program type -->
                <div
                    class="flex justify-between items-end w-full mt-auto"
                    style="z-index: 2"
                >
                    <div
                        style="
                            display: inline-flex;
                            padding: 2px 12px;
                            justify-content: center;
                            align-items: center;
                            border-radius: 999px;
                            border: 0.793px solid var(--Border-Light, #e2e8f0);
                        "
                    >
                        <span
                            style="
                                color: var(--text-icons-tertiary, #64748b);
                                font-family: Inter;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 16px;
                            "
                        >
                            {{ programTypeLabel }}
                        </span>
                    </div>
                    <div></div>
                </div>

                <!-- Check icon -->
                <div
                    class="absolute -bottom-4 right-4 flex items-center justify-center h-10 w-10"
                    style="
                        display: inline-flex;
                        padding: 8px;
                        align-items: center;
                        border-radius: 2397.6px;
                        background: #34c759;
                        box-shadow:
                            0px 1px 2px 0px rgba(0, 0, 0, 0.05),
                            0px 1px 2px 0px rgba(0, 0, 0, 0.06);
                        z-index: 2;
                    "
                >
                    <svg
                        class="h-6 w-6 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.5 12.75l6 6 9-13.5"
                        />
                    </svg>
                </div>
            </div>
        </div>

        <!-- Confirmation message -->
        <div
            class="text-center text-slate-800 dark:text-slate-100 text-lg font-medium leading-7 mt-8 mb-2 z-10 relative font-['Inter']"
        >
            Program successfully added
        </div>

        <!-- SVG Background -->
        <div class="svg-background">
            <IconProgram icon="program-background" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import IconProgram from '@/components/ui/icon/icon-program.vue';

const props = defineProps({
    chosenProgram: { type: Object, default: null },
    formattedPoints: { type: String, required: true },
    programType: { type: String, default: null },
    getProgramImageUrl: { type: Function, required: true },
});

const programTypeLabel = computed(() => {
    if (props.programType === 'airline') return 'Airline';
    if (props.programType === 'hotel') return 'Hotel';
    if (props.programType === 'rail') return 'Rail';
    return 'Flexible Currency';
});
</script>
